import React from 'react';
import './banner.scss';

export function Banner() {
  return (
    <section>
      <div class='marquee'>
        <ul class='marquee__content'>
          <li>Analysts report pay-outs of up to £30 billion to Car Finance Customer due to secret commissions^</li>
        </ul>

        <ul aria-hidden='true' class='marquee__content'>
          <li>Analysts report pay-outs of up to £30 billion to Car Finance Customer due to secret commissions^</li>
        </ul>
      </div>
    </section>
  );
}
